import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteTextMessage = async (id: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteTextMessage($id: ID!) {
        deleteTextMessage(id: $id)
      }
    `),
    variables: {
      id,
    },
  });

  return response.data?.deleteTextMessage ?? false;
};
